module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "vm-notification-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vm-notification",
    class: _vm.customClass,
    style: ({
      top: _vm.top ? _vm.top + 'px' : 'auto'
    }),
    on: {
      "mouseenter": function($event) {
        _vm.clearTimer()
      },
      "mouseleave": function($event) {
        _vm.startTimer()
      },
      "click": _vm.click
    }
  }, [(_vm.type || _vm.iconClass) ? _c('i', {
    staticClass: "vm-notification__icon",
    class: [_vm.typeClass, _vm.iconClass]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vm-notification__group",
    class: {
      'is-with-icon': _vm.typeClass || _vm.iconClass
    }
  }, [_c('h2', {
    staticClass: "vm-notification__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vm-notification__content"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "vm-notification__close vm-notification-icon--close",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bd5e7ffa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-bd5e7ffa","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/notification.vue
// module id = 18
// module chunks = 0